import { useMemo } from 'react'
import { z, type ZodSchema } from '@sevenrooms/form'

export type AvailabilityDatesModalForm = ZodSchema<typeof useAvailabilityDatesFormSchema>
export const useAvailabilityDatesFormSchema = () =>
  useMemo(
    () =>
      z.object({
        startDate: z.date(),
      }),
    []
  )
